export const APP_VERSION = "0.1.0";
